import { cloneDeep } from 'es-toolkit';

const TopDupesDetails = ({
  dupes = [],
  additionalListingSources = [],
  isTopDupe = false,
  hasManualDupe = false,
  sourceCount = null,
  topDupeManualListingAlias = '',
  topDupeAliasEncoded = '',
} = {}) => ({
  dupes: cloneDeep(dupes) as Array<{
    active?: boolean;
    aliasEncoded?: string;
    feedName?: string;
    listingId?: string;
  }>,
  additionalListingSources: cloneDeep(additionalListingSources),
  isTopDupe: Boolean(isTopDupe),
  hasManualDupe: Boolean(hasManualDupe),
  sourceCount: Number(sourceCount),
  topDupeManualListingAlias: String(topDupeManualListingAlias),
  topDupeAliasEncoded: String(topDupeAliasEncoded),
});

export default TopDupesDetails;

export type TopDupesDetailsProps = ReturnType<typeof TopDupesDetails>;
